import * as React from "react"
import type { SVGProps } from "react"
const SvgRecommendationReciprocated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.95 4.26a7.8 7.8 0 0 1 6.1.84q.52.3 1 .67.47.38.87.84.3.32.25.74a1 1 0 0 1-.42.66q-.36.22-.76.17a1.2 1.2 0 0 1-.7-.38q-.27-.3-.58-.53a6.2 6.2 0 0 0-5.24-1.07A5.8 5.8 0 0 0 6.8 9l-.08.15 1.23-.33q.38-.1.74.11t.47.6q.1.36-.11.74a1 1 0 0 1-.6.46l-3.54.96a.96.96 0 0 1-1.22-.7l-.95-3.56a1 1 0 0 1 .11-.74q.22-.37.6-.47.37-.1.74.11t.46.6L5 8.14 5.1 8a7.7 7.7 0 0 1 4.86-3.74M8.95 17.17a6 6 0 0 1-.65-.44q-.3-.23-.57-.53-.3-.32-.72-.38a1 1 0 0 0-.77.16 1 1 0 0 0-.41.64q-.06.42.23.72a7.9 7.9 0 0 0 7.99 2.4A7.7 7.7 0 0 0 18.92 16l.08-.15.33 1.23q.1.37.47.59.38.2.75.1a1 1 0 0 0 .58-.46q.21-.37.11-.75l-.95-3.55a.96.96 0 0 0-1.2-.7l-3.56.95a1 1 0 0 0-.58.47 1 1 0 0 0-.12.75q.1.37.47.59.37.2.75.1l1.22-.32-.08.15a5.8 5.8 0 0 1-3.65 2.8q-2.4.63-4.59-.63" />
  </svg>
)
export default SvgRecommendationReciprocated
